
let defaultState = {

    visible: false, 
    link: "link",

    state: "SPACE_SWITCH", // SPEECH_ERROR, LINK_SHARE, SPACE_SWITCH, CREATING_LINK

    speechError: false,
}

export default function (state=defaultState, action) {

    switch(action.type) {

        case "HUD_ENABLE":
            return Object.assign({}, defaultState, {
                visible: true,
            })
        
        case "HUD_DISABLE":
            return Object.assign({}, defaultState, {
                visible: false,
            })
        
        case "HUD_SET_LINK":
            return Object.assign({}, defaultState, {
                visible: true,
                state: "LINK_SHARE",
                link: action.link,
            })
        
        case "HUD_SPEECH_ERROR":
            return Object.assign({}, defaultState, {
                // speechError: true,
                state: "SPEECH_ERROR",
                visible: true,
            })
        
        case "HUD_LOADING":
            return Object.assign({}, defaultState, {
                state: "CREATING_LINK",
                visible: true,
            })
        
        case "HUD_SPACE_SELECT":
            return Object.assign({}, defaultState, {
                state: "SPACE_SWITCH",
                visible: true,
            })
        
        case "SWITCH_SPACE":
            return Object.assign({}, defaultState, {
                visible: false,
            })

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/hud.js